const l = {
  name: "minus-bold",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M3 12c0-1.105.711-2 1.588-2h14.824c.877 0 1.588.895 1.588 2s-.711 2-1.588 2H4.588C3.711 14 3 13.105 3 12Z" clip-rule="evenodd"/></svg>',
  keywords: ["minus-bold"],
  category: "utility"
};
export {
  l as minusBold
};
//# sourceMappingURL=minus-bold.es.js.map
